import React from "react";
import PrimaryButton from "web/react/components/buttons/primary-button/primary-button";
import GenericModal from "web/react/components/generic-modal/generic-modal";
import { gettext } from "web/script/modules/django-i18n";
import styles from "./cookie-read-more-modal.css";

interface CookieReadMoreProps {
    isOpen: boolean;
    onModalClose: () => void;
    title: string;
    content: string;
}

export default function CookieReadMoreModal({
    isOpen,
    onModalClose,
    title,
    content,
}: CookieReadMoreProps): JSX.Element {
    return (
        <GenericModal
            isOpen={isOpen}
            onClose={onModalClose}
            className={styles.modal}
            noScroll={false}
        >
            <div className={styles.readMoreWrapper}>
                <div className={styles.readMoreTitle}>{title}</div>
                <div className={styles.contentWrapper}>
                    <div
                        className={styles.readMoreContent}
                        dangerouslySetInnerHTML={{ __html: content }}
                    ></div>
                </div>
                <PrimaryButton
                    className={""}
                    fullHeight={false}
                    fullWidth={true}
                    openInNewTab={false}
                    disabled={false}
                    onClick={onModalClose}
                >
                    {gettext("general.done")}
                </PrimaryButton>
            </div>
        </GenericModal>
    );
}
